export enum ENDPOINT_URLS {
  APPLICATION = 'application',
  APPLICATION_GROUP = 'application-group',
  ACCOUNT = 'account',
  TARIFF = 'tariff',
  METER = 'meter',
  METER_POINT = 'meter-point',
  ABILITY_ROLE = 'ability-role',
  API_KEY = 'api-key',
  XERO_INTEGRATION = 'xero-integration2',
  XERO_TAX_RATE = 'xero-tax-rate',
  XERO_ACCOUNT = 'xero-account',
  UTILITY_DATA = 'utility-data',
  UTILITY_DATA_VIEW = 'utility-data-view',
  UTILITY = 'utility',
  TARIFF_STRUCTURE = 'tariff-structure',
  TARIFF_VERSION = 'tariff-version',
  TRANSACTION = 'transaction',
  PAYMENT = 'payment',
  USER = 'user',
  GATEWAY = 'gateway',
  GATEWAY_ONBOARDING = 'gateway-onboarding',
  GLOBAL_SEARCH = 'global-search',
  REPORT = 'report',
  REPORT_LAYOUT = 'report-layout',
  RECON = 'recon',
  NOTIFICATION = 'notification',
  PUSH_NOTIFICATION = 'push-notification',
  MODBUS_COMMAND = 'modbus-command',
  DASHBOARD = 'dashboard',
  EMAIL_INTEGRATION = 'email-integration',
  EMAIL_WHITELIST = 'email-integration-whitelist',
  MANUAL_READINGS = 'manual-readings',
  MANUAL_READING_LOG = 'manual-reading-log',
  DEBT = 'debt-recovery-transaction',
  ALERT = 'alert',
  AUDIT_LOG = 'audit-log',
  METER_LOG = 'meter-log',
  METER_TASK = 'meter-task',
  BILLING_REGISTER_DATA = 'billing-register-data',
  MDMS_LOG = 'mdms-log',
  ZONE = 'zone',
  PROVIDER = 'provider',
  JOB = 'job',
  BULK_APPLICATION_SETUP = 'bulk-application-setup',
  PAYMENT_INTEGRATION = 'payment-integration',
  METERING_INTEGRATION = 'metering-integration',
  SENSOR = 'sensor',
  SENSOR_DATA = 'sensor-data',
  CHART_OF_ACCOUNT = 'chart-of-account',
  INVOICE = 'invoice',
  JOURNAL_ENTRY = 'journal-entry',
  ACCOUNTING = 'accounting',
  DEVICE_REGISTRY = 'device-registry',
  UTILITY_DATA_WORKSPACE = 'utility-data-workspace',
}

export const API_ROUTES = {
  utilityData: {
    base: ENDPOINT_URLS.UTILITY_DATA,
    aggregate: `${ENDPOINT_URLS.UTILITY_DATA}/aggregateP1ReadingsByBucket`,
    p1Split: `${ENDPOINT_URLS.UTILITY_DATA}/aggregateP1Split`,
  },
  recon: {
    base: ENDPOINT_URLS.RECON,
  },
  report: {
    base: ENDPOINT_URLS.REPORT,
  },
  reportLayout: {
    base: ENDPOINT_URLS.REPORT_LAYOUT,
  },
};

export const TAG_TYPES: readonly string[] = [
  ...Object.values(ENDPOINT_URLS),
  'IotState',
  'Proxy',
  'ProxyAllowlist',
];

export enum TagId {
  PARTIAL_LIST = 'PARTIAL-LIST',
}

export enum API_METHODS {
  POST = 'POST',
  DELETE = 'DELETE',
  GET = 'GET',
  PATCH = 'PATCH',
  PUT = 'PUT',
}
